export default __webpack_public_path__ + "static/media/5.ea72aae1.jpg";